// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"651":"12b4e2ed","768":"2fa7e3ad","777":"d54d93bd"}[chunkId] + ".css";
};